import { screenOf } from '../game/session.js';
import { useApp } from '../store.js';
import { Jersey } from './Jersey.js';

/** Вызов от друга в открытой игре. Во время матча не мешаем — окно появится после него. */
export function IncomingInvite() {
  const invite = useApp((s) => s.incomingInvite);
  const screen = useApp(screenOf);
  const answer = useApp((s) => s.answerIncoming);
  if (!invite || screen === 'match' || screen === 'splash') return null;
  return (
    <div className="overlay invite-in" role="dialog" aria-label="Вызов от друга">
      <Jersey kit={invite.from.kit} className="invite-in__kit" />
      <p>
        {invite.kind === 'DUEL'
          ? `${invite.from.name} вызывает вас на дуэль!`
          : `${invite.from.name} зовёт в кубок с друзьями на ${invite.size}`}
      </p>
      <button type="button" className="play play--small" onClick={() => void answer(true)}>
        ⚔️ Принять
      </button>
      <button type="button" className="link" onClick={() => void answer(false)}>
        Не сейчас
      </button>
    </div>
  );
}
